import AddressWarningModal from './AddressWarningModal';

export default AddressWarningModal;
